import { type ValueOf } from '@/lib/utils/type'

export const CASE_TABLE_TAB_MAP = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
} as const

export const CASE_TABLE_TABS: {
  label: string
  value: ValueOf<typeof CASE_TABLE_TAB_MAP>
}[] = [
  {
    label: 'Active Cases',
    value: CASE_TABLE_TAB_MAP.ACTIVE,
  },
  {
    label: 'Inactive Cases',
    value: CASE_TABLE_TAB_MAP.INACTIVE,
  },
]
